<template>
  <div>
    <span :class="isAvailable ? 'online' : 'offline'">
      {{ isAvailable ? $t('Online') : $t('Offline') }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isAvailable() {
      return this.user && this.user.profile.onlineStatus === 'online'
    },
  },
}
</script>

<style lang="scss" scoped>
span {
  font-family: 'Inter', sans-serif !important;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
.online {
  color: #0fcc45;
}
.offline {
  color: #f00;
}
</style>
